module.exports = __webpack_public_path__ + "static/media/HIGH.7b9417c5.png";